import {Component, DoCheck, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router, RouterStateSnapshot} from '@angular/router';
import {FormBuilder, Validators} from '@angular/forms';
import {SurveyService} from '../../../services/surveys.service';
import {ToastService} from '../../../services/general/toast.service';
import {TranslateService} from '@ngx-translate/core';
import {MatStepper} from '@angular/material/stepper';
import {UserService} from '../../../services/user.service';
import {HeaderTitleService} from '../../../services/general/header-title.service';
import {isEqual} from 'lodash-es';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';


@Component({
  selector: 'app-survey-response-page',
  templateUrl: './survey-response-page.component.html',
  styleUrls: ['./survey-response-page.component.scss']
})
export class SurveyResponsePageComponent implements OnInit, OnDestroy, DoCheck {
  @ViewChild('stepper', {static: false}) stepper: MatStepper;
  userInfoForm = this._formBuilder.group({
    firstCtrl: ['', Validators.required],
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _formBuilder: FormBuilder,
    private surveyService: SurveyService,
    public userService: UserService,
    private toast: ToastService,
    private translateService: TranslateService,
    private headerTitleService: HeaderTitleService
  ) {
  }

  loading = false;
  survey_id = null;
  survey = null;
  autoSaveLoading = false;

  private surveySnapshot: any = null;
  private surveyChange$ = new Subject<void>();
  private surveyChangeSub: any;

  ngOnInit(): void {
    this.init();
  }

  init() {
    this.route.params.subscribe(params => {
      this.survey_id = params.survey_id;
      this.getSurvey();
    });
  }


  ngDoCheck() {
    if (this.survey && !isEqual(this.survey, this.surveySnapshot)) {
      this.surveySnapshot = JSON.parse(JSON.stringify(this.survey));
      this.surveyChange$.next();
    }
  }

  ngOnDestroy() {
    if (this.surveyChangeSub) {
      this.surveyChangeSub.unsubscribe();
    }
  }

  getSurvey() {
    this.loading = true;
    this.surveyService.surveyDetailsResponsePage(this.survey_id, (result) => {
      if (result?.is_draft) {
        this.router.navigate(['/']);
      }

      const draft = result?.draft?.customs?.draft;
      delete result?.draft;
      this.survey = result;
      if (draft) {
        this.survey = draft;
      }

      if (result.visibility_type === 'PRIVATE') {
        this.userService.getUser(() => {
          this.userService.resetCurrentLanguage();
        });
      }
      if (!this.userService.userInfo) {
        this.survey.user = {
          name: '',
          email: '',
        };
      }
      this.headerTitleService.setTitle(result.title);
      this.survey.edit_after_submit = !!this.survey.edit_after_submit;
      this.survey.attachments = result.attachment_files?.concat(result.attachment_pubmeds);
      setTimeout(() => {
        this.surveyChangeSub = this.surveyChange$
          .pipe(debounceTime(5000))
          .subscribe(() => {
            if (this.survey && !this.autoSaveLoading) {
              this.autoSave();
            }
          });
      }, 5000);
      this.loading = false;
    }, (error) => {
      this.router.navigate(['/']);
      this.loading = false;
    });
  }

  surveyResponseIsValid() {
    const status = this.surveyService.surveyAnswerIsValid(this.survey);
    // @ts-ignore
    if (!status?.valid) {
      // @ts-ignore
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant(status?.message));
      return false;
    }

    return true;
  }

  onSubmit(is_draft = false) {
    const submit = () => {
      this.loading = true;
      this.surveyService.createSurveyAnswer(this.survey_id, this.survey, (result) => {
        if (!is_draft) {
          this.stepper.next();
          this.survey.answered = true;
        }
        this.toast.success(
          this.translateService.instant('generic.success'),
          this.translateService.instant(is_draft ? 'pages.surveys.response.drafted-successfully' : 'pages.surveys.response.submitted-successfully'),
        );
        this.loading = false;
      }, () => {
        this.loading = false;
      });
    };

    this.survey.is_draft = is_draft;
    if (is_draft) {
      submit();
    } else {
      if (this.surveyResponseIsValid()) {
        submit();
      }
    }
  }

  autoSave() {
    this.survey.is_draft = true;
    this.autoSaveLoading = true;
    this.surveyService.createSurveyAnswer(this.survey_id, this.survey, (result) => {
      this.autoSaveLoading = false;
    }, () => {
      this.autoSaveLoading = false;
    });
  }
}
